import { callGlobalFunction } from "./utils.js";

export const searchFeature = {
  openTab() {
    return callGlobalFunction("switchTab", "search");
  },
  renderResults() {
    return callGlobalFunction("renderSearchResults");
  },
  updateProviderFilter() {
    return callGlobalFunction("updateProviderFilter");
  },
  updateClientProviderFilter() {
    return callGlobalFunction("updateClientProviderFilter");
  }
};
